<template>
  <sl-page>
    <Tree :data="data" :render="renderContent" style="max-width:500px;"></Tree>
    <menu-item ref="item" @on-update="handleUpdate"></menu-item>
  </sl-page>
</template>
<script>
import menuItem from './detail'

export default {
  components: { menuItem },

  data() {
    return {
      data: [{
        title: '后台菜单',
        expand: true,
        level:0,
        children: []
      }],
      visible: false,
    }
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      this.loading = true
      this.$request.menuQueryAll().then(resp => {
        if (!resp.code) {
          let d = this.$utils.conv(resp.data || [], { title: i => i.name+'('+i.code.replace(/\-/g,'_')+')' })
          d.forEach( i => {
            i.expand = true
          })
          d.sort((a,b) => {
            return a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0
          })
          this.data[0].children = this.$utils.tree(d, 'id', 'parentId', 'children', 0)
        }
      })
    },
    renderRoot(h, { root, node, data }){
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [

        h('span', { style:{marginLeft:'8px'}},data.title),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
          }
        }, [
          h('Button', {
            props: {
              size: 'small',
              icon: 'md-add-circle',
              type:'primary'
            },
            directives: [
              {
                name: 'permission',
                value: 'system.menu.insert',
              }
            ],
            style: {
              width: '52px',
              marginRight: '32px'
            },
            on: {
              click: () => {
                this.create(data)
              }
            }
          })
        ])
      ]);
    },
    renderContent(h, { root, node, data }) {

      if (data.level === 0) {
        return this.renderRoot(h, { root, node, data })
      }

      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [

        h('span', { style:{marginLeft:'8px'}},data.title),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
          }
        }, [
          h('Button', {
            props: {
              size: 'small',
              icon: 'md-add-circle'
            },
            style: {
              marginRight: '8px'
            },
            directives: [
              {
                name: 'permission',
                value: 'system.menu.insert',
              }
            ],
            on: {
              click: () => {
                this.create(data)
              }
            }
          }),
          h('Button', {
            props: {
              size: 'small',
              icon: 'md-close-circle'
            },
            style: {
              marginRight: '8px'
            },
            directives: [
              {
                name: 'permission',
                value: 'system.menu.delete',
              }
            ],
            on: {
              click: () => {
                this.remove(data)
              }
            }
          }),
          h('Button', {
            props: {
              size: 'small',
              icon: 'md-create'
            },
            style: {
              marginRight: '8px'
            },
            directives: [
              {
                name: 'permission',
                value: 'system.menu.update',
              }
            ],
            on: {
              click: () => {
                this.edit(data)
              }
            }
          }),
        ])
      ]);
    },
    append(data) {
      const children = data.children || [];
      children.push({
        title: 'appended node',
        expand: true
      });
      this.$set(data, 'children', children);
    },
    create(data) {
      this.$refs['item'].create( data )
    },
    remove(data) {
      this.$ui.confirm(this.$request.menuDelete ,  `确定删除菜单${data.name}？`)({ ids: [data.id] }).then( resp => {
        if(!resp.code){
          this.$Message.success('删除成功')
          this.init()
        }else{
          this.$Message.error({content:resp.msg})
        }
      })

    },
    edit(data) {
      // this.$refs['item'].edit( data )
      this.$refs['item'].init( data.id )
    },
    handleUpdate(){
      this.init()
    }
  }
}

</script>
